import { render, staticRenderFns } from "./PillsList.vue?vue&type=template&id=73443666&"
var script = {}
import style0 from "./PillsList.vue?vue&type=style&index=0&id=73443666&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports